
import { useState, useEffect } from 'react';
import { getSubdomain, getOrganizationFromSubdomain, isMainDomain } from '@/utils/subdomain';

export const useSubdomain = () => {
  const [subdomain, setSubdomain] = useState<string | null>(null);
  const [organization, setOrganization] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMain, setIsMain] = useState(true);

  useEffect(() => {
    const checkSubdomain = async () => {
      try {
        setIsLoading(true);
        const currentSubdomain = getSubdomain();
        const mainDomain = isMainDomain();
        
        setSubdomain(currentSubdomain);
        setIsMain(mainDomain);
        
        if (currentSubdomain && !mainDomain) {
          const org = await getOrganizationFromSubdomain(currentSubdomain);
          setOrganization(org);
        }
      } catch (error) {
        console.error('Error checking subdomain:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkSubdomain();
  }, []);

  return {
    subdomain,
    organization,
    isLoading,
    isMainDomain: isMain
  };
};
